import { Store } from "@reduxjs/toolkit";
import type { RootState } from "..";

import type SpaceRepositoryInterface from "../../modules/spaces/domain/space/space.repository.interface";
import SpaceRepository from "../../modules/spaces/infrastructure/repository/space.repository";

export const EntitiesRepositories = {
  SpaceRepository,
};

export interface Repositories {
  SpaceRepository: SpaceRepositoryInterface;
}

export const instantiateRepositories = (
  store: Store<RootState>,
): Repositories => ({
  SpaceRepository: new SpaceRepository(store),
});
